export default __webpack_public_path__ + "static/media/r7.1d7e4516.png";